// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"65":"35905480","87":"d1104368","328":"a16c1d0f","453":"0a369b16","469":"96d54c27","639":"84554db2","644":"195969a5","767":"6c56355f","799":"e0976219","849":"1da48feb","952":"6388b40d"}[chunkId] + ".chunk.js";
};